import { render, staticRenderFns } from "./HealthScoreAssessment.vue?vue&type=template&id=6f339666"
import script from "./HealthScoreAssessment.vue?vue&type=script&lang=js"
export * from "./HealthScoreAssessment.vue?vue&type=script&lang=js"
import style0 from "./HealthScoreAssessment.vue?vue&type=style&index=0&id=6f339666&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports